import { toFormat } from '../data/dates';

export default ({ datetime, format }) => {
  return datetime ? toFormat(format)(datetime) : null;
};
